import styled from 'styled-components';

export const CardColumns = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
`;

export const CardColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
